<template>
  <div v-if="value != 100" class="progress">
    <div :class="`progress__donut progress__donut--${percentage}`" />
    <span class="progress__label">
      {{ percentage ? `${percentage}% complete` : 'Unstarted' }}
    </span>
  </div>
  <span v-else class="pill">Completed</span>
</template>

<script>
export default {
  name: 'PlaylistProgress',
  components: {},
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  computed: {
    percentage() {
      const value = this.value * 100

      // eslint-disable-next-line eqeqeq
      if (value == 100) return 100
      if (value >= 75) return 75
      if (value >= 50) return 50
      if (value >= 25) return 25

      return value
    },
  },
}
</script>

<style lang="scss">
.progress {
  display: flex;
  align-items: center;
  &__donut {
    border: 3px solid var(--tundora-gray);
    width: 24px;
    height: 24px;
    box-sizing: border-box;
    border-radius: 50%;
    transform: rotate(45deg);
    &--25 {
      border-color: var(--positive-light) var(--tundora-gray)
        var(--tundora-gray) var(--tundora-gray);
    }
    &--50 {
      border-color: var(--positive-light) var(--positive-light)
        var(--tundora-gray) var(--tundora-gray);
    }
    &--75 {
      border-color: var(--positive-light) var(--positive-light)
        var(--positive-light) var(--tundora-gray);
    }
  }
  &__label {
    margin-left: 10px;
  }
}
.pill {
  padding: 5px 8px;
  border-radius: 30px;
  color: var(--charcoal);
  background: var(--positive-light);
  box-shadow: 0px 0px 10px rgba(112, 255, 212, 0.5);
}
</style>
